module.exports = __webpack_public_path__ + "static/media/profileIcon.22dcb618.png";